import React from 'react';
import RightSideDrawer from '../../ui/RightSideDrawer';
import Stack from "@mui/material/Stack";
import {Typography} from "@mui/material";


interface NotificationsDrawerProps {
    open: boolean;
    onClose: () => void;
}

const NotificationsDrawer: React.FC<NotificationsDrawerProps> = ({ open, onClose }) => {

    return (
        <RightSideDrawer title={'Benachrichtigungen'} open={open} onClose={onClose} width={450}>
            <Stack>
                <Typography variant="body2" color="textSecondary">Keine aktuellen Benachrichtigungen</Typography>
            </Stack>
        </RightSideDrawer>
    );
};

export default NotificationsDrawer;